export enum Measurement {
    Units = 'Units',
    Liters = 'Liters',
    Kilograms = 'Kilograms',
    Meters = 'Meters',
    Days = 'Days',
    Hours = 'Hours'
}
